"use client";

import { useSettingPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/settings/useSettingPersistQuickAddOnSearchTile";

export const MaybePersistQuickAddOnSearch: React.FC<{
  hoverQuickAdd: React.ReactNode;
  nonHoverQuickAdd: React.ReactNode;
  showOnHover: boolean;
}> = ({ hoverQuickAdd, nonHoverQuickAdd, showOnHover }) => {
  const shouldPersistQuickAdd = useSettingPersistQuickAddOnSearchTile();
  return !shouldPersistQuickAdd && showOnHover
    ? hoverQuickAdd
    : nonHoverQuickAdd;
};
